export default __webpack_public_path__ + "7efdffade73a002d1728a3ea93d69180.svg";